export default "/images/trading.svg?1cd28d8b784c046e18129351736fd9e7";